// extracted by mini-css-extract-plugin
export default {"pattern":"Hero_pattern__Jz33M"};